const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const APP_NAME = 'Asset Management System';
const ALGORITHM_KEY = '9sf*!8=0+89r6cf^twytp6$iptoak@*+x%w=oc)v%@@q$3&)@l';

export { BASE_URL, APP_NAME, ALGORITHM_KEY };
